import { render, staticRenderFns } from "./ClickRateByTemplate.vue?vue&type=template&id=74721126&"
import script from "./ClickRateByTemplate.vue?vue&type=script&lang=js&"
export * from "./ClickRateByTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ClickRateByTemplate.vue?vue&type=style&index=0&id=74721126&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports